export default __webpack_public_path__ + "static/weel-homepage-animation-c5426e6b2669c000f490dc7c2aff1e0e.mp4";